import PatientForm from '../../../../components/authorised/appointment/PatientForm'
import * as $ from 'jquery';
import { quickActions, quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions';
import { useDispatch } from 'react-redux';
import { patientEditCancel } from '../../../../redux/actions/patient/patientActions';
import { reset } from 'redux-form';

export default function PatientFullMode(props) {
  const { patient } = props
  const dispatch = useDispatch()

  const handlePatientFullModeClose = () => {
    $('#fullModePatient-modal').modal('hide')
    handlePatientEditCancel(patient)
  }

  const handlePatientEditCancel = () => {
    dispatch(patientEditCancel());
    $('#quickActionPatientForm-modal').modal('hide');
    dispatch(quickActions({ select_patient_modal: false }))
    dispatch(quickActionsReset())
    dispatch(reset('secondaryPatientForm'))
  }

  return (
    <div>
      <div className="modal fade" id="fullModePatient-modal" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div className="modal-dialog m-0 min-width-full" role="document">
          <div className="modal-content bg-light">
            <div className='py-4 px-6 d-flex justify-content-end patient-full-mode-head position-fixed z-index-9'>
              <button className='btn btn-primary' onClick={handlePatientFullModeClose}>Close</button>
            </div>
            <PatientForm wrapperClasses="w-100" isQuickAction={true} />
          </div>
        </div>
      </div>
    </div>
  )
}